//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserService } from '../../../../services/user-service';
import { IGroup, OrgType } from '../../../../types/group';
import { IUser } from '../../../../types/user';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import authHelper from '../../../auth/authHelper';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-priority-lock-banner',
    templateUrl: './priority-lock-banner.component.html',
    styleUrls: ['./priority-lock-banner.component.scss'],
    standalone: false
})
export class PriorityLockBannerComponent implements OnInit, OnDestroy {
  user: IUser;
  org: IGroup;
  private intervalId: number;

  securityLockEngaged$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly refresh$: BehaviorSubject<void> = new BehaviorSubject<void>(null);

  // securityLockEngaged = false;
  wait_time = 10000; // 60 seconds

  constructor(public userService: UserService) {
  }

  ngOnInit(): void {
    this.userService.api_get_user_info()
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.user = user;
        this.userService.get_organization(authHelper.getGroupFromToken())
          .pipe(untilDestroyed(this))
          .subscribe((org) => {
            if (org.org_type === OrgType.CUSTOMER) {
              this.checkPriorityLock(org);
              this.intervalId = window.setInterval(() => this.refresh$.next(null), this.wait_time);
          }
      });
    });
  }

  ngOnDestroy() {
    clearTimeout(this.intervalId);
  }

  checkPriorityLock(orgParam): void {
    this.check_org_value(orgParam);
    this.refresh$
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.userService.get_organization(authHelper.getGroupFromToken())
          .pipe(untilDestroyed(this))
          .subscribe((org) => {
            this.check_org_value(org);
        });
    });
  }

  private check_org_value(orgParam) {
    this.org = orgParam;
    if (this.org && this.org.priority_lock_engaged) {
      this.securityLockEngaged$.next(true);
    } else {
      this.securityLockEngaged$.next(false);
    }
  }
}
